import {
  SOCKET_NEW_TASKMAP,
  SOCKET_LEAVE_TASKMAP,
  SOCKET_CHANGE_BNB,
  SOCKET_UPDATE_TASKMAP,
  SOCKET_UPDATE_TASK,
  SOCKET_DELETE_TASKMAP,
  MANITIZED_CHANELL_EDITTOR_TEXT,
  NEW_CHANNEL_MESSAGE_SOCKET,
  GET_BOARD_CHANNEL_MESSAGES,
  SET_CHANNEL_MESSAGES_LOADING,
  SET_CHANNEL_MESSAGES_LOADING_FALSE,
  GET_BOARD_TASKMAP_CHANNEL_MESSAGES,
  NEW_TASKMAP_CHANNEL_MESSAGE_SOCKET,
  SOCKET_LEAVE_TASKMAP_ROOM,
  SOCKET_NEW_CHAT_BOARD_MESSAGE,
  CHANGED_TASK_STATUS_SOCKET,
  CHANGED_TASK_READY_SOCKET,
  CHANEL_FILE_UPLOAD_VALUE,
  CHANEL_VOICE_UPLOAD_VALUE,
  Delete_TASKMAP_CHANNEL_MESSAGE_SOCKET,
  CHANGED_TASKMAP_PRIORITY_SOCKET,
  IMPORT_TASKMAPS,
  USER_WORKING_SHARESCREEN_MEID,
  USERS_WORKING_ROOMS,
  USERS_WORKING_SOCKETID,
  USER_RECIEVE_CALL_SHARE_SCREEN,
  USER_ACCEPTED_CALL_SHARE_SCREEN,
  LEAVE_CALL_SHARE_SCREEN,
  PEERS_SHARE_SCREEN_WEBRTC,
  Delete_CHANNEL_MESSAGE_SOCKET,
  SEEN_CHAT_BOARD_MESSAGE,
  REMOVE_USERS_WEBRTC,
  REMOVE_EDDITOR_TEXT,
  REACT_BOARD_CHANNEL_MESSAGE,
  BOARD_CHANNEL_LOAD_OLDER_REQUEST,
  BOARD_CHANNEL_LOAD_OLDER_SUCCESS,
  BOARD_CHANNEL_LOAD_OLDER_FAIL,
  TASKMAP_CHANNEL_LOAD_OLDER_REQUEST,
  TASKMAP_CHANNEL_LOAD_OLDER_SUCCESS,
  TASKMAP_CHANNEL_LOAD_OLDER_FAIL,
} from "./SocketTaskTypes";
import {
  EDIT_BOARD_CHANNEL_MESSAGE,
  EDIT_TASKMAP_MESSAGE,
  GET_BOARD_CHANNEL_TOPICS,
} from "./TasksType";

export const BoardChanellDataReducer = (
  state = {
    Loading: true,
    loadingOlderMessages: false,
    messagesPagination: null,
    EdittorData: {
      __html: "<p></p>",
    },
    OldMessages: [],
    Topics: [],
  },
  action
) => {
  switch (action.type) {
    case GET_BOARD_CHANNEL_TOPICS: {
      return { ...state, Topics: action.Payload };
    }
    case MANITIZED_CHANELL_EDITTOR_TEXT: {
      return { ...state, EdittorData: action.Payload };
    }
    case REMOVE_EDDITOR_TEXT: {
      return { ...state, EdittorData: { __html: "<p></p>" } };
    }
    case SET_CHANNEL_MESSAGES_LOADING: {
      return { ...state, Loading: true };
    }
    case SET_CHANNEL_MESSAGES_LOADING_FALSE: {
      return { ...state, Loading: false };
    }
    case GET_BOARD_CHANNEL_MESSAGES: {
      const messages = action.Payload ?? [];
      const messagesPagination = action.messagesPagination ?? state.messagesPagination;
      return { ...state, Loading: false, OldMessages: messages, messagesPagination };
    }
    case BOARD_CHANNEL_LOAD_OLDER_REQUEST:
      return { ...state, loadingOlderMessages: true };
    case BOARD_CHANNEL_LOAD_OLDER_SUCCESS: {
      const olderMessages = action.Payload ?? [];
      const existingIds = new Set((state.OldMessages || []).map((m) => String(m._id)));
      const dedupedOlder = olderMessages.filter(
        (m) => !existingIds.has(String(m._id)),
      );
      const merged = [...dedupedOlder, ...(state.OldMessages || [])];
      return {
        ...state,
        loadingOlderMessages: false,
        OldMessages: merged,
        messagesPagination: action.messagesPagination ?? state.messagesPagination,
      };
    }
    case BOARD_CHANNEL_LOAD_OLDER_FAIL:
      return { ...state, loadingOlderMessages: false };
    case NEW_CHANNEL_MESSAGE_SOCKET: {
      const payload = action.Payload;
      if (payload._replaceTempId) {
        const idx = state.OldMessages.findIndex(
          (m) => String(m._id) === String(payload._replaceTempId),
        );
        if (idx >= 0) {
          const clean = { ...payload };
          delete clean._replaceTempId;
          const newMessages = [...state.OldMessages];
          newMessages[idx] = clean;
          return { ...state, OldMessages: newMessages };
        }
      }
      if (payload._markFailedId) {
        const messages = state.OldMessages.map((m) =>
          String(m._id) === String(payload._markFailedId)
            ? { ...m, _status: "failed", _errorMessage: payload._errorMessage }
            : m,
        );
        return { ...state, OldMessages: messages };
      }
      const alreadyExists = state.OldMessages.some(
        (m) => String(m._id) === String(payload._id),
      );
      if (alreadyExists) return state;
      return {
        ...state,
        OldMessages: [...state.OldMessages, payload],
      };
    }
    case Delete_CHANNEL_MESSAGE_SOCKET: {
      const data1 = state.OldMessages;
      const Filtered1 = data1.filter((item) => item._id !== action.Payload);
      return { ...state, OldMessages: Filtered1 };
    }
    case EDIT_BOARD_CHANNEL_MESSAGE: {
      let OldMessages1 = state.OldMessages;
      const FindMessage1 = OldMessages1.find(
        (item) => item._id === action.Payload.body._id
      );
      const FindIndexTM1 = OldMessages1.indexOf(FindMessage1);
      OldMessages1[FindIndexTM1] = action.Payload.body;
      return { ...state, OldMessages: [...OldMessages1] };
    }
    case REACT_BOARD_CHANNEL_MESSAGE: {
      const { MessageID, reactions } = action.Payload ?? {};
      const messages = (state.OldMessages || []).map((m) =>
        String(m._id) === String(MessageID)
          ? { ...m, Reactions: reactions }
          : m,
      );
      return { ...state, OldMessages: messages };
    }
    default: {
      return state;
    }
  }
};

export const BoardTaskMapChanellDataReducer = (
  state = {
    Loading: true,
    loadingOlderMessages: false,
    messagesPagination: null,
    EdittorData: "",
    OldMessages: [],
  },
  action
) => {
  switch (action.type) {
    case MANITIZED_CHANELL_EDITTOR_TEXT: {
      return { ...state, EdittorData: action.Payload };
    }
    case SET_CHANNEL_MESSAGES_LOADING: {
      return { ...state, Loading: true };
    }
    case SET_CHANNEL_MESSAGES_LOADING_FALSE: {
      return { ...state, Loading: false };
    }
    case GET_BOARD_TASKMAP_CHANNEL_MESSAGES: {
      const messages = action.Payload ?? [];
      const messagesPagination = action.messagesPagination ?? state.messagesPagination;
      return { ...state, Loading: false, OldMessages: messages, messagesPagination };
    }
    case TASKMAP_CHANNEL_LOAD_OLDER_REQUEST:
      return { ...state, loadingOlderMessages: true };
    case TASKMAP_CHANNEL_LOAD_OLDER_SUCCESS: {
      const olderMessages = action.Payload ?? [];
      const existingIds = new Set((state.OldMessages || []).map((m) => String(m._id)));
      const dedupedOlder = olderMessages.filter(
        (m) => !existingIds.has(String(m._id)),
      );
      const merged = [...dedupedOlder, ...(state.OldMessages || [])];
      return {
        ...state,
        loadingOlderMessages: false,
        OldMessages: merged,
        messagesPagination: action.messagesPagination ?? state.messagesPagination,
      };
    }
    case TASKMAP_CHANNEL_LOAD_OLDER_FAIL:
      return { ...state, loadingOlderMessages: false };
    case NEW_TASKMAP_CHANNEL_MESSAGE_SOCKET: {
      const payload = action.Payload;
      if (payload._replaceTempId) {
        const idx = state.OldMessages.findIndex(
          (m) => String(m._id) === String(payload._replaceTempId),
        );
        if (idx >= 0) {
          const clean = { ...payload };
          delete clean._replaceTempId;
          const newMessages = [...state.OldMessages];
          newMessages[idx] = clean;
          return { ...state, OldMessages: newMessages };
        }
      }
      if (payload._markFailedId) {
        const messages = state.OldMessages.map((m) =>
          String(m._id) === String(payload._markFailedId)
            ? { ...m, _status: "failed", _errorMessage: payload._errorMessage }
            : m,
        );
        return { ...state, OldMessages: messages };
      }
      const alreadyExists = state.OldMessages.some(
        (m) => String(m._id) === String(payload._id),
      );
      if (alreadyExists) return state;
      return {
        ...state,
        OldMessages: [...state.OldMessages, payload],
      };
    }
    case Delete_TASKMAP_CHANNEL_MESSAGE_SOCKET: {
      const data1 = state.OldMessages;
      const Filtered1 = data1.filter((item) => item._id !== action.Payload);
      return { ...state, OldMessages: Filtered1 };
    }
    case EDIT_TASKMAP_MESSAGE: {
      let OldMessages1 = state.OldMessages;
      const FindMessage1 = OldMessages1.find(
        (item) => item._id === action.Payload.body._id
      );
      const FindIndexTM1 = OldMessages1.indexOf(FindMessage1);
      OldMessages1[FindIndexTM1] = action.Payload.body;
      return { ...state, OldMessages: [...OldMessages1] };
    }
    case REACT_BOARD_CHANNEL_MESSAGE: {
      const { MessageID, reactions } = action.Payload ?? {};
      const messages = (state.OldMessages || []).map((m) =>
        String(m._id) === String(MessageID)
          ? { ...m, Reactions: reactions }
          : m,
      );
      return { ...state, OldMessages: messages };
    }
    case SOCKET_LEAVE_TASKMAP_ROOM: {
      return { ...state, SocketMessages: [] };
    }
    default: {
      return state;
    }
  }
};

export const NewChatBoardMessageReducer = (
  state = {
    Loading: true,
    EdittorData: "",
    ChatMessages: [],
  },
  action
) => {
  switch (action.type) {
    case MANITIZED_CHANELL_EDITTOR_TEXT: {
      return { ...state, EdittorData: action.Payload };
    }
    case SOCKET_NEW_CHAT_BOARD_MESSAGE: {
      return {
        ...state,
        Loading: false,
        ChatMessages: [...state.ChatMessages, action.Payload],
      };
    }
    case SEEN_CHAT_BOARD_MESSAGE: {
      let data1 = state.ChatMessages;
      const FindMessage1 = data1.filter((item) => item._id === action.Payload);
      const FindIndex1 = data1.indexOf(FindMessage1[0]);
      data1[FindIndex1].Seen = true;
      return {
        ...state,
        ChatMessages: [...data1],
      };
    }
    default: {
      return state;
    }
  }
};

export const ShareWorkingUsersScreenReducer = (
  state = {
    me: "",
    SocketID: "",
    Users: [],
    CallUser: null,
    AcceptCall: null,
    LeaveCall: null,
    peers: [],
  },
  action
) => {
  switch (action.type) {
    case USER_WORKING_SHARESCREEN_MEID: {
      return { ...state, me: action.Payload };
    }
    case USERS_WORKING_ROOMS: {
      return { ...state, Users: action.Payload };
    }
    case USERS_WORKING_SOCKETID: {
      return { ...state, SocketID: action.Payload };
    }
    case USER_RECIEVE_CALL_SHARE_SCREEN: {
      return { ...state, CallUser: action.Payload };
    }
    case USER_ACCEPTED_CALL_SHARE_SCREEN: {
      return { ...state, AcceptCall: action.Payload };
    }
    case LEAVE_CALL_SHARE_SCREEN: {
      return { ...state, LeaveCall: action.Payload };
    }
    case PEERS_SHARE_SCREEN_WEBRTC: {
      return { ...state, peers: action.Payload };
    }
    case REMOVE_USERS_WEBRTC: {
      return { ...state, Users: [] };
    }
    default: {
      return state;
    }
  }
};
